import { useCallback, useState } from 'react';
import { useLang } from 'hooks/lang';

import { Tabs, Column } from 'components/Blocks';
import { DemographicsForm, defaultDemographics } from 'pages/Projects/components';

import { CreateProjectDispatchAction } from '../types';
import { FullProject } from 'entities';

import { getFirst } from 'utils/array';

interface DemographicsProps {
  countries: string[];
  demographics: FullProject['demographics'];
  dispatch: CreateProjectDispatchAction;
}

export function Demographics({
  countries,
  demographics,
  dispatch,
}: DemographicsProps): JSX.Element {
  const [tab, setTab] = useState(getFirst(countries));

  const { t } = useLang();

  const handleChange = useCallback(
    (name: string, value: string | boolean) => {
      dispatch({
        demographics: (old) => ({
          ...old.demographics,
          [tab]: {
            ...old.demographics[tab],
            [name]: value,
          },
        }),
      });
    },
    [dispatch, tab],
  );

  return (
    <Column>
      <h6>{t('demographics')}</h6>

      <Tabs
        onTabChange={setTab}
        tabListClassName="-mt-2"
        type="highlighted"
        value={tab}
        tabs={countries.map((country) => ({
          value: country,
          label: country,
        }))}
      />

      <DemographicsForm
        demographics={demographics[tab] || defaultDemographics}
        handleChange={handleChange}
      />
    </Column>
  );
}
